import { PublicClientApplication } from '@azure/msal-browser'

const msalConfig = {
  auth: {
    clientId: process.env.VUE_APP_AZURE_CLIENT_ID,
    authority: 'https://login.microsoftonline.com/common',
    redirectUri: `${window.location.origin}/auth/sso-callback`,
  },
  cache: { cacheLocation: 'sessionStorage' },
}

const loginRequest = { scopes: ['openid', 'profile', 'email'] }
const msalInstance = new PublicClientApplication(msalConfig)

export { msalInstance, loginRequest }
